import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm">
    <ol className="flex flex-wrap items-center gap-1 text-slate-600">
      {items.map((it, i) => (
        <li key={it.to} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5" aria-hidden />}
          {i === items.length - 1 ? (
            <span aria-current="page" className="text-[#0B2150] font-medium">{it.name}</span>
          ) : (
            <Link to={it.to} className="hover:text-[#027A6D] hover:underline">{it.name}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
